module.exports = __webpack_public_path__ + "static/img/10007 (5).e3cf72f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10007 (5).webp
// module id = sm6I
// module chunks = 14